// ————————————————————————————————————————————— DOC. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const cnslStyles = {
  default: "color: orange; font-weight: bold;",
  success: "color: green; font-weight: bold;",
  error: "color: red; font-weight: bold;",
};

const msgs = {
  start: "toggle_activeNavLink() called",
  complete: "toggle_activeNavLink() complete",
  setActive: (id) => `Setting active link to ID: ${id}`,
  qry: (id, nav) => `querying for a[href="#${id}"] in `,
  prefix_err: "toggle_activeNavLink() error:",
};

const msgs_err = {
  noActiveBg: "No activeBg element found in provided nav.",
  noLink: (id) => `No link found in provided nav for ID: ${id}`,
};

// ——————————————————————————————————————— API METHOD DEF. ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function toggle_activeNavLink(el_nav, id_active = null) {
  ////////////// Setup ///////////////
  ////////////////////////////////////

  console.log(`%c[SectionScroller] ${msgs.start}`, cnslStyles.default);

  ////////////// ACTION //////////////
  ////////////////////////////////////

  const activeBg = el_nav.querySelector("[data-ref='activeBg']");
  if (!activeBg) {
    console.log(`%c[SectionScroller] ${msgs.prefix_err} ${msgs_err.noActiveBg}`, cnslStyles.error);
    return;
  }

  console.log(msgs.setActive(id_active));
  // console.log(msgs.qry(id_active), el_nav);

  const link_toSetActive = id_active ? el_nav.querySelector(`a[data-target="${id_active}"]`) : el_nav.querySelector("a");
  // console.log(" el_nav", el_nav);
  // console.log(" id_active", id_active);
  // console.log(" link_toSetActive", link_toSetActive);
  if (!link_toSetActive) {
    console.log(`%c[SectionScroller] ${msgs.prefix_err} ${msgs_err.noLink(id_active)}`, cnslStyles.error);
    return;
  }

  const rect_link_toSetActive = link_toSetActive.getBoundingClientRect();
  activeBg.style.setProperty("--w-btn", `${rect_link_toSetActive.width}px`);
  activeBg.style.setProperty("--l", `calc(${link_toSetActive.offsetLeft}px - var(--p))`);

  ///////////// Conclude /////////////
  ////////////////////////////////////

  console.log(`%c[SectionScroller] ${msgs.complete}`, cnslStyles.success);
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
